import "./collapsible-panel.scss";

import { useState } from "react";
import { Collapse, Image } from "react-bootstrap";
import { typedMemo, CollapsiblePanelProps } from "src/types";
import { concatClasses } from "src/utils";

export const CollapsiblePanel = typedMemo(
  ({
    defaultExpanded = false,
    titleHead,
    head,
    iconHead,
    fixedChildren,
    collapsibleChildren,
    classes = "d-flex justify-content-between",
    classesHead = "m-0 p-2 d-flex justify-content-between flex-nowrap",
    classesTitle = "m-0 p-0 font-medium-m",
    classesIconHead = "",
    arrowVersus = "bottom",
    iconHeadContainerClass = "",
    classesBottom = "m-0 p-2 d-flex justify-content-end flex-nowrap",
    iconBottom,
    classesIconBottom = "",
    iconBottomContainerClass = "",
    titleBottom,
    bottom,
    onToggle,
  }: CollapsiblePanelProps) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    const Head = (
      <div className={classesHead}>
        {head || <div className={classesTitle}>{titleHead}</div>}
        {iconHead && (
          <div
            className={concatClasses(
              iconHeadContainerClass,
              "align-items-center"
            )}
          >
            <Image
              src={iconHead}
              width={18}
              height={18}
              className={concatClasses(
                `icon-v${arrowVersus}`,
                classesIconHead,
                expanded ? `rotate-v${arrowVersus}` : ""
              )}
            />
          </div>
        )}
      </div>
    );

    const Bottom = (
      <div
        className={classesBottom}
        role="button"
        onClick={() => {
          setExpanded((prev) => {
            const newState = !prev;
            onToggle?.(newState);
            return newState;
          });
        }}
      >
        {bottom || <div className={classesTitle}>{titleBottom}</div>}
        {iconBottom && (
          <div
            className={concatClasses(
              iconBottomContainerClass,
              "align-items-center"
            )}
          >
            <Image
              src={iconBottom}
              width={18}
              height={18}
              className={concatClasses(
                `icon-v${arrowVersus}`,
                classesIconBottom,
                expanded ? `rotate-v${arrowVersus}` : ""
              )}
            />
          </div>
        )}
      </div>
    );

    const Collapsible = (
      <Collapse in={expanded}>
        <div className="m-0 p-0">{collapsibleChildren}</div>
      </Collapse>
    );

    return (
      <main className={classes}>
        {Head}
        {fixedChildren}
        {Collapsible}
        {Bottom}
      </main>
    );
  }
);
